// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._2q5_vdXLdNnsytdgsErg {
  width: 100%;
  background-color: var(--top-block-background);
}

.yuqIgCBwc_JTbKTwqEcp {
  padding-top: 1.5rem;
  padding-bottom: 3rem;
}

.lxMRvkWZGVwBbc5uKjhp {
  display: flex;
  justify-content: center;
  width: 100%;
}

.C_oPyd3L89ErBC4N6dz7 {
  position: relative;
  width: 100%;
  max-width: 39.75rem;
  height: 18.3125rem;
}

.MQ7nIjGz8A4rhym_I_9_ {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 39.75rem;
  height: 22.3125rem;
  border-radius: 0.5rem;
  object-fit: cover;
}

.sjMybTh1B4bGzeMnWFlY {
  text-align: center;
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .C_oPyd3L89ErBC4N6dz7 {
    max-width: 100%;
    height: 15rem;
  }

  .MQ7nIjGz8A4rhym_I_9_ {
    width: 100%;
    height: 16.375rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .C_oPyd3L89ErBC4N6dz7 {
    max-width: 100%;
    height: 10.9375rem;
  }

  .MQ7nIjGz8A4rhym_I_9_ {
    width: 100%;
    height: 12.625rem;
  }

  .yuqIgCBwc_JTbKTwqEcp {
    padding: 1.0625rem 0 2.0625rem 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TopBlockWithImage/TopBlockWithImage.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,mBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAgB;EAChB,kBAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,eAAY;EACZ,kBAAa;EACb,qBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EACE;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,WAAW;IACX,iBAAa;EACf;AACF;;AAEA;;EACE;IACE,eAAe;IACf,kBAAa;EACf;;EAEA;IACE,WAAW;IACX,iBAAa;EACf;;EAEA;IACE,gCAAsB;EACxB;AACF","sourcesContent":[".topBlockWithImage {\n  width: 100%;\n  background-color: var(--top-block-background);\n}\n\n.link {\n  padding-top: 24px;\n  padding-bottom: 48px;\n}\n\n.imageWrapper {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.imageInnerWrapper {\n  position: relative;\n  width: 100%;\n  max-width: 636px;\n  height: 293px;\n}\n\n.image {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 636px;\n  height: 357px;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n.title {\n  text-align: center;\n}\n\n@media (--tablet) {\n  .imageInnerWrapper {\n    max-width: 100%;\n    height: 240px;\n  }\n\n  .image {\n    width: 100%;\n    height: 262px;\n  }\n}\n\n@media (--mobile) {\n  .imageInnerWrapper {\n    max-width: 100%;\n    height: 175px;\n  }\n\n  .image {\n    width: 100%;\n    height: 202px;\n  }\n\n  .link {\n    padding: 17px 0 33px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topBlockWithImage": `_2q5_vdXLdNnsytdgsErg`,
	"link": `yuqIgCBwc_JTbKTwqEcp`,
	"imageWrapper": `lxMRvkWZGVwBbc5uKjhp`,
	"imageInnerWrapper": `C_oPyd3L89ErBC4N6dz7`,
	"image": `MQ7nIjGz8A4rhym_I_9_`,
	"title": `sjMybTh1B4bGzeMnWFlY`
};
export default ___CSS_LOADER_EXPORT___;
